<template>
  <div>
    <transition name="slide-fade-in" mode="out-in">
      <payment-form v-if="!slug" @success="slug = $event"/>
      <div v-else>
        <h1>Thank you</h1>
        <p>Thank you for your payment. You'll receive a receipt in your email.</p>
        <p>Your confirmation code is: <em>{{slug}}</em>.</p>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref } from "vue"
import PaymentForm from "@/components/bill_pay/public_form/PaymentForm"

export default {
  components: {PaymentForm},
  setup() {
    return {
      slug: ref(undefined)
    }
  }
}
</script>

<style>
.slide-fade-in-enter-from {
  transform: translateX(-10px);
  opacity: 0;
}
.slide-fade-in-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-in-enter-active,
.slide-fade-in-leave-active {
  transition: all 0.5s ease;
}
</style>
